import React, { useState, useEffect } from 'react';

const AUDITORES = ['Mirelli', 'Angela', 'Veronica', 'Marta', 'Alexandre'];

function BloquearDiaModal({ isOpen, onClose, onSave }) {
  const [auditor, setAuditor] = useState(AUDITORES[0]);
  const [data, setData] = useState('');
  const [motivo, setMotivo] = useState('');

  useEffect(() => {
    // Limpa os campos sempre que o modal abre
    if (isOpen) {
      setData(new Date().toISOString().split('T')[0]);
      setMotivo('');
      setAuditor(AUDITORES[0]);
    }
  }, [isOpen]);

  if (!isOpen) return null;

  const handleSave = () => {
    if (!data || !motivo) {
      alert('Por favor, preencha todos os campos.');
      return;
    }
    onSave({
      auditor,
      data,
      motivo,
    });
    onClose();
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <h2>Bloquear Dia na Agenda</h2>
        <div className="form-group">
          <label>Auditor</label>
          <select value={auditor} onChange={(e) => setAuditor(e.target.value)}>
            {AUDITORES.map(nome => <option key={nome} value={nome}>{nome}</option>)}
          </select>
        </div>
        <div className="form-group">
          <label>Data para Bloquear</label>
          <input
            type="date"
            value={data}
            onChange={(e) => setData(e.target.value)}
            required
          />
        </div>
        <div className="form-group">
          <label>Motivo do Bloqueio (ex: Férias)</label>
          <input
            type="text"
            value={motivo}
            onChange={(e) => setMotivo(e.target.value)}
            required
            autoFocus
          />
        </div>
        <div className="modal-actions">
          <button type="button" onClick={onClose} className="btn-cancel">Cancelar</button>
          <button type="button" onClick={handleSave} className="btn-save">Salvar Bloqueio</button>
        </div>
      </div>
    </div>
  );
}

export default BloquearDiaModal;